/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminSeedTeamMember
 */
export interface AdminSeedTeamMember {
    /**
     * 
     * @type {string}
     * @memberof AdminSeedTeamMember
     */
    discordId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSeedTeamMember
     */
    gamertag?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSeedTeamMember
     */
    displayName: string;
}

/**
 * Check if a given object implements the AdminSeedTeamMember interface.
 */
export function instanceOfAdminSeedTeamMember(value: object): value is AdminSeedTeamMember {
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    return true;
}

export function AdminSeedTeamMemberFromJSON(json: any): AdminSeedTeamMember {
    return AdminSeedTeamMemberFromJSONTyped(json, false);
}

export function AdminSeedTeamMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminSeedTeamMember {
    if (json == null) {
        return json;
    }
    return {
        
        'discordId': json['discordId'] == null ? undefined : json['discordId'],
        'gamertag': json['gamertag'] == null ? undefined : json['gamertag'],
        'displayName': json['displayName'],
    };
}

export function AdminSeedTeamMemberToJSON(json: any): AdminSeedTeamMember {
    return AdminSeedTeamMemberToJSONTyped(json, false);
}

export function AdminSeedTeamMemberToJSONTyped(value?: AdminSeedTeamMember | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'discordId': value['discordId'],
        'gamertag': value['gamertag'],
        'displayName': value['displayName'],
    };
}

